<template>
  <div class="container" :class="{'section-loading': releaseLoading}">
    <div class="row">
      <div class="col-12">
        <h4 class="text-green  m-0">發文注意事項：</h4>
      </div>
      <div class="col-12">
        <p>
          1. 不得發布身分證字號、保單號碼及其他『足資識別該個人之資料』相關資訊。 <br />
          2. 上傳之文件或影片等文件不得構成著作財產權之侵害。 <br />
          3. 若有發現違法之情事，經查屬實後管理者得將違法者停權並送人資議處。 <br />
        </p>
      </div>
      <table class="table table-basic mt-4 mb-4">
        <thead>
          <tr>
            <th class="w-220">發文單位</th>
            <td>{{ UserInfo.divFullName }}</td>
          </tr>
          <tr>
            <th class="w-220">申請者</th>
            <td>{{ UserInfo.name }}</td>
          </tr>
        </thead>
      </table>
      <table class="table table-basic mt-4 mb-4">
        <thead>
          <tr>
            <th class="w-220">公告對象</th>
            <td v-if="departShow">轄下所有單位</td>
            <td v-else>單位所有人</td>
          </tr>
          <tr>
            <th class="w-220">主旨<br /><small style="color:black;">最多20個字元(10個中文字)</small></th>
            <td class="d-flex">
              <input type="text" :class="titleDisabled?'input-border-red':''" class="form-control w-50" v-model="release_data.title">
              <div v-if="titleDisabled" class="d-flex align-items-center text-danger ml-2">已超過最大字數</div>
            </td>
          </tr>
          <tr>
            <th class="w-220">內文<br /><small style="color:black;">(最多100個中文字)</small></th>
            <td> <textarea class="form-control" rows="5" v-model="release_data.content"></textarea>
            <div v-if="contentDisabled" class="d-flex align-items-center text-danger ml-2">已超過最大字數</div>
            </td>
          </tr>
          <tr>
            <th class="w-220">連結方式</th>
            <td>
              <div class="radio radio-inline" v-for="(single, index) in link" :key="`bulletin-link-${index}`">
                <input type="radio" :id="`bulletin-link-${index}`" name="bulletin-link" :value="single.value" v-model="release_data.link_way">
                <label :for="`bulletin-link-${index}`">{{ single.name }}</label>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220">發佈日期</th>
            <td  class="d-flex">
              <date-picker
                v-model="release_data.release_date"
                :format="dateFormatter"
                :language="dateLang"
                :first-day-of-week="1" />
                <div class="d-flex align-items-center" style="margin-left: 12px;font-size: 22px;color:#F58818">
                  <i class="icon-calendar"  />
                </div>
            </td>
          </tr>
          <tr>
            <th class="w-220">下架日期</th>
            <td  class="d-flex">
              <date-picker
                v-model="release_data.takeoff_date"
                :format="dateFormatter"
                :language="dateLang"
                :first-day-of-week="1" />
                <div class="d-flex align-items-center" style="margin-left: 12px;font-size: 22px;color:#F58818">
                  <i class="icon-calendar"  />
                </div>
            </td>
          </tr>
        </thead>
      </table>
      <table class="table table-basic mt-4 mb-4" v-if="release_data.link_way !== 0">
        <thead>
          <tr v-if="release_data.link_way === 1">
            <th class="w-220">網頁連結</th>
            <td><input type="text" class="form-control" v-model="release_data.web_link"></td>
          </tr>
          <tr v-if="release_data.link_way === 2">
            <th class="w-220">檔案位置</th>
            <td class="d-flex">
              <input id="file-upload" ref="myFiles" type="file" @change="changeInput()"/>
              <input type="text" v-model="release_data.file_link" id="file-text" class="form-control w-25 mr-2" />
              <label for="file-upload" class="custom-file-upload btn btn-default m-0" >
                上傳檔案
              </label>
              <!-- <input type="file" class="form-control w-50" > -->
              <div class="d-flex align-items-center" style="margin-left: 12px;font-size: 22px;color:#F58818">
                <i class="icon-attach"  /> <span style="font-size:16px;">檔案限定PDF、PNG、JPG，大小不得超過5MB</span>
              </div>
            </td>
          </tr>
        </thead>
      </table>
      <div class="col-12">
        <div class="action text-right">
          <a class="btn btn-default" @click="cancalRelease">
          取消
          </a>
          <a  class="btn btn-primary" @click="submitRelease" :disabled="titleDisabled || contentDisabled">
          確定
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import { getTacount, releaseAddNews } from '@/service'
import DatePicker from '@/components/DatePicker/components/Datepicker'
import {en, zh} from '@/components/DatePicker/locale'
import { userInfo } from 'os';
import { debuglog } from 'util';

export default {
  name: 'ReleaseNotice',
  mixins: [commonMixin],
  components: {
    DatePicker
  },
  computed: {
    ...mapGetters(['UserInfo']),
    departShow () {
      return this.UserInfo.roleId.includes('01')
    },
  },
  watch: {
    'release_data.title': {
      handler: function(val, oldVal) {
        if(this.stringBytes(val) > 20) {
          this.titleDisabled = true;
        }else{
          this.titleDisabled = false;
        }
      },
    },
    'release_data.content': {
      handler: function(val, oldVal) {
        if(val.length > 100) {
          this.contentDisabled = true;
        }else{
          this.contentDisabled = false;
        }
      },
    },
  },
  data () {
    return {
      releaseLoading: false,
      memberCount: '0',
      release_data: {
        link_way: 0,
        title: '',
        content: '',
        release_date: '',
        takeoff_date: '',
        web_link: '',
        file_link: '',
      },
      dateLang: zh,
      dateFormatter: (date) => {
        const m = date.getMonth() + 1
        const d = date.getDate()
        return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
      },
      link: [
        {
          'name': '無連結',
          'value': 0
        },
        {
          'name': '網頁連結',
          'value': 1
        },
        {
          'name': '檔案附件',
          'value': 2
        }
      ],
      titleDisabled: false,
      contentDisabled: false,
      file: {}
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    stringBytes(c){ //計算字元長度
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
            len++;
            s = s >> 8;
        }
      }
      return len;
    },
    cancalRelease() {
       this.$router.push({path:`/manager/BulletinBoard/tab/1`})
    },
    fmDate (date) {  // 轉換 Date 物件為 'YYYY-MM-DD' string
      let nowDateY = date.getYear().toString().replace(/^./,'20')
      let nowDateM = (date.getMonth() + 1).toString().length == 1 ? `0${(date.getMonth() + 1).toString()}` : (date.getMonth() + 1).toString()
      let nowDateD = date.getDate().toString().length == 1 ? `0${date.getDate().toString()}` : date.getDate().toString()
      return `${nowDateY}-${nowDateM}-${nowDateD}`
    },
    dataCheck () {  // 進行資料驗證
      if(this.release_data.title.length == 0) {
        this.setToastMsg('主旨不得為空')
        return false
      }
      
      if(this.release_data.title.length > 20) {
        this.setToastMsg('主旨不得超過20個字')
        return false
      }

      if(this.release_data.content.length == 0) {
        this.setToastMsg('內文不得為空')
        return false
      }

      if(this.release_data.content.length > 100) {
        this.setToastMsg('內文不得超過100個字')
        return false
      }

      // 計算 發佈 下架 相差天數
      const dateRange = this.mixDateDiff(this.release_data.release_date ,this.release_data.takeoff_date)
      if(dateRange < 0 || dateRange > 14) {
        this.setToastMsg('「發佈時間」距離「下架時間」最多2週，且「發佈時間」不得超過「下架時間」')
        return false
      }

      if(this.release_data.release_date.length == 0) {
        this.setToastMsg('「發佈時間」不得為空')
        return false
      }

      if(this.release_data.takeoff_date.length == 0) {
        this.setToastMsg('「下架時間」不得為空')
        return false
      }

      // 確認「發佈時間」需大於或等於編輯日期
      if (this.mixDateDiff(null , this.release_data.release_date) < 0) {
        this.setToastMsg('「發佈時間」需大於或等於編輯日期')
        return false
      }

      if (this.release_data.link_way == '1' && this.release_data.web_link == '') {
        this.setToastMsg('「網頁連結」不得為空')
        return false
      }

      // 全部驗證通過
      return true
    },
    submitRelease() {
      if(this.dataCheck()){  // 進行資料驗證
        let reprotData = {}
        let nowDateY = moment().year().toString()
        let nowDateM = (moment().month() + 1).toString()
        let nowDateD = moment().date().toString()
        if(nowDateM.length == 1){ nowDateM = `0${nowDateM}`}
        if(nowDateD.length == 1){ nowDateD = `0${nowDateD}`}
        reprotData.CLASS = this.departShow ? '2' : '3' // 發佈層級
        reprotData.SUBJECT = this.release_data.title || '' // 主旨
        reprotData.WORDS = this.release_data.content || '' // 內文
        reprotData.DVNO = this.UserInfo.divNo || '' // 申請者的單位代號
        reprotData.DVNM = this.UserInfo.divShortName || '' // 申請單位名稱
        reprotData.EMP_ID = this.UserInfo.id || '' // 申請者的ID
        reprotData.EMP_NM = this.UserInfo.name || '' // 申請人姓名
        // reprotData.DDATE = `${nowDateY}-${nowDateM}-${nowDateD}` // 第一次申請的時間   
        reprotData.STAR_DATE = this.fmDate(this.release_data.release_date) // 發佈日期  
        reprotData.END_DATE = this.fmDate(this.release_data.takeoff_date) // 下架日期  
        // reprotData.UPD_TIME = `${nowDateY}-${nowDateM}-${nowDateD}` // 最後一次編輯的時間  
        reprotData.HTTP = this.release_data.web_link // 網頁連結
        reprotData.FILENAME = this.release_data.file_link // 檔案名稱
        reprotData.UPD_ID = this.UserInfo.id || '' // 最後一次編輯者的ID
        reprotData.UPD_NM = this.UserInfo.name || '' // 最後一次編輯者的姓名
        reprotData.CEADCD = this.UserInfo.mktDeptNo || '' // 區部代號
        reprotData.TA_COUNT = this.memberCount || '' // 對象總人數
        reprotData.LINK_WAY = this.release_data.link_way + '' // 連結方式

        //  連結方式是檔案附件
        let fileData = ''
        const vm = this
        if (vm.release_data.link_way == '2') {
          
          // 使用 formData 上傳檔案
          releaseAddNews(vm.UserInfo.id, reprotData, vm.$refs.myFiles.files[0]).then(result => {
            if(result.header && result.header.status == '200'){
              vm.setToastMsg(result.header.message)
              vm.$router.push({path:`/manager/BulletinBoard/tab/1`})
            }else{
              vm.setToastMsg(result.header.message)
            }
          })
          
          // 下面是轉成純 array

          // let fileReader = new FileReader()
          // fileReader.onload = function () {
          //   let fileData = this.result
          //   // let uintAry = new Uint8Array(this.result)
          //   // fileData = Array.from(uintAry)
          //   // console.log('arrayBuffer', this.result)
          //   // console.log('uintAry', uintAry)
          //   // console.log('fileData', fileData)
          //   // vm.setToastMsg('轉換成功：', fileData)
          //   releaseAddNews(vm.UserInfo.id, reprotData, fileData).then(result => {
          //     if(result.header && result.header.status == '200'){
          //       vm.setToastMsg(result.header.message)
          //       vm.$router.push({path:`/manager/BulletinBoard/tab/1`})
          //     }else{
          //       vm.setToastMsg(result.header.message)
          //     }
          //   })
          // }
          // fileReader.readAsArrayBuffer(vm.$refs.myFiles.files[0])
        } else {
          releaseAddNews(this.UserInfo.id, reprotData, fileData).then(result => {
            if(result.header && result.header.status == '200'){
              this.setToastMsg(result.header.message)
              this.$router.push({path:`/manager/BulletinBoard/tab/1`})
            }else{
              this.setToastMsg(result.header.message)
            }
          })
        }

      }
    },
    changeInput() { 
      const vm = this
      vm.file = vm.$refs.myFiles.files[0];
      console.log(vm.file)
      let fileType = vm.file.type;
      //檢查檔案類型 (只允許 application/pdf, image/png, image/jpeg)
      if (fileType.indexOf('pdf') !== -1 || fileType.indexOf('png') !== -1 || fileType.indexOf('jpeg') !== -1) {
        //檢查檔案大小
        if(vm.$refs.myFiles.files[0].size > 5000000) {
          vm.setToastMsg('檔案大小不得超過5MB')
          vm.file = {};
          vm.release_data.file_link = ''
        } else {
          vm.release_data.file_link = vm.file.name
        }
      } else {
        vm.setToastMsg('檔案格式只允許pdf, png, jpg');
        vm.release_data.file_link = '';
      }
    },
    initRelease () {   // 初始化發布
      let reportData = {
        divno: '',
        isdepno: '',
        depno: '',
      }
      if(this.UserInfo.roleId.includes('01')) { // 判斷是否為 主管(區部) 主管(經理)
        reportData.depno = this.UserInfo.mktDeptNo
        reportData.isdepno = '1'
      } else {
        reportData.divno = this.UserInfo.divNo
        reportData.isdepno = '0'
      }
      this.releaseLoading = true
      getTacount(this.UserInfo.id, reportData).then(result => {  // 取得對象總人數
        this.releaseLoading = false
        if(result.header && result.header.status == '200') {
          this.memberCount = result.body.count
        }
      })
      this.registerHanlink()
    }, 
  },
  mounted () {
    this.initRelease()  // 初始化發布
  }
}
</script>
<style>
input[type="file"] {
    display: none;
}
.custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
}
</style>